var rb = require('crypto').randomBytes;
module.exports = function() {
  return rb(16);
};



//////////////////
// WEBPACK FOOTER
// ./~/ethpm-registry/~/uuid/rng.js
// module id = 2310
// module chunks = 0 1